<template>
  <div class="product-container" :class="divClass">
    <span class="product-title">{{ props.product.titulo }}</span><br/>
    <span class="product-amounts">Comprados: {{ props.product.cantidad }}<br/>Canjeados: {{ props.product.cantidad_canjeada }}</span>
    <span class="status-tag" :class="statusTagClass">{{ productStatus }}</span>
    <div class="buttons-container">
      <img src="@/assets/images/ic_product_minus.png" class="quantity-button" :class="minusButtonClass" alt="Remove product" @click="decreaseQuantity" />
      <span class="quantity">{{ cantidad }}</span>
      <img src="@/assets/images/ic_product_plus.png" class="quantity-button" :class="plusButtonClass" alt="Remove product" @click="increaseQuantity" />
    </div>
  </div>
</template>
  
<script setup>
  import { defineEmits, defineExpose, defineProps, ref, computed } from 'vue';
  
  const props = defineProps({
    status: String,
    product: Object,
  });
  
  const productStatus = ref("");
  const cantidad = ref(0);

  if (props.product == null) {
    productStatus.value = "";
  } else if (props.product.cantidad == props.product.cantidad_canjeada) {
    productStatus.value = "Canjeado";
  } else if (props.product.cantidad_canjeada > 0) {
    productStatus.value = "Canjeado parcial.";
  } else if (props.status === 'Pendiente') {
    productStatus.value = "Vigente";
  } else if (props.status === 'Caducado') {
    productStatus.value = "Caducado";
  } else {
    productStatus.value = "";
  }

  const divClass = computed(() => {
    if (props.product.cantidad == props.product.cantidad_canjeada){
      return "redeemed";
    } else if (props.status === 'Pendiente'){
      return "pending";
    } else { //if (props.status === 'Caducado'){
      return "expired";
    }
  });

  const statusTagClass = computed(() => {
    if (props.product.cantidad == props.product.cantidad_canjeada){
      return "status-tag-redeemed";
    } else if (props.product.cantidad_canjeada > 0) {
      return "status-tag-partially-redeemed";
    } else if (props.status === 'Pendiente'){
      return "status-tag-pending";
    } else { //if (props.status === 'Caducado'){
      return "status-tag-expired";
    }
  })

  const minusButtonClass = computed(() => {
    if (cantidad.value == 0) {
      return "button-disabled";
    } else {
      return "button-enabled"
    }
  });

  const plusButtonClass = computed(() => {
    if (cantidad.value == props.product.cantidad - props.product.cantidad_canjeada) {
      return "button-disabled";
    } else {
      return "button-enabled"
    }
  });

  const emit = defineEmits(['update:quantity']);

  const decreaseQuantity = () => {
    if (cantidad.value > 0) {
      cantidad.value--;
      emit('update:quantity', cantidad.value);
    }
  }

  const increaseQuantity = () => {
    if (cantidad.value < props.product.cantidad - props.product.cantidad_canjeada && props.status === 'Pendiente') {
      cantidad.value++;
      emit('update:quantity', cantidad.value);
    }
  }
  
  const selectAllExecuted = () => {
    cantidad.value = props.product.cantidad - props.product.cantidad_canjeada;
    emit('update:quantity', cantidad.value);
  };

  defineExpose({ selectAllExecuted });

</script>
  
<style scoped>  

.product-container {
  border-radius: 10px;
  padding: 12px;
  margin-top: 15px;
  position: relative;
}

.product-title {
  font-weight: bold;
  font-size: 1.10em;
}

.product-amounts {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.9em;
}

.pending {
  background-color: var(--primary-color);
}

.redeemed {
  background-color: var(--light-gray);
  opacity: 0.4;
}

.expired {
  background-color: var(--light-gray);
  opacity: 0.4;
}

.status-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 0.75em;
  border-radius: 20px;
  padding: 3px;
  min-width: 105px;
  text-align: center;
}

.status-tag-pending {
  background-color: #D3F9F0;
}

.status-tag-redeemed {
  background-color: var(--gray);
  color: white;
}

.status-tag-partially-redeemed {
  background-color: #F5BA5D;
}

.status-tag-expired {
  background-color: #F15A58cc;
  color: white;
}

.buttons-container {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-button {
  height: 30px;
  width: 30px;
}

.quantity {
  align-self: center;
  font-weight: bold;
  font-size: 1.5em;
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
  min-width: 30px;
}

.button-disabled {
  opacity: 0.5;
}

.button-enabled {
  opacity: 1;
}

</style>
  